import { Component, Input, OnInit } from '@angular/core';
import { Guideline } from 'src/app/_model/guidline';

@Component({
  selector: 'app-guidlines',
  templateUrl: './guidlines.component.html',
  styleUrls: ['./guidlines.component.scss']
})
export class GuidlinesComponent implements OnInit {
@Input() guideline: Guideline;
  constructor() { }

  ngOnInit(): void {
  }

}
